const AUTH_STORAGE_KEYS = ['bp_access_token', 'bp_refresh_token'];

function safeRemove(storage, key) {
  try {
    storage?.removeItem?.(key);
  } catch {}
}

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => {
    safeRemove(localStorage, key);
    safeRemove(sessionStorage, key);
  });
}

export function getAccessToken() {
  try {
    return localStorage.getItem('bp_access_token');
  } catch {
    return null;
  }
}

export function getRefreshToken() {
  try {
    return localStorage.getItem('bp_refresh_token');
  } catch {
    return null;
  }
}

export function setAuthTokens({ accessToken, refreshToken }) {
  try {
    if (accessToken) localStorage.setItem('bp_access_token', accessToken);
    if (refreshToken) localStorage.setItem('bp_refresh_token', refreshToken);
  } catch {}
}
